// @ts-nocheck
const init = (el: HTMLElement) => {
  const children = el.childNodes;
  let totalHeight:number = 0;

  const wrapper: HTMLElement = el.querySelector('.product-description__expandable')
  const toggle: HTMLElement = el.querySelector('.product-description__toggle');
  const close: HTMLElement = el.querySelector('.product-description__toggle--close')

  children.forEach(child => {
    if(child.offsetHeight != undefined) {
      totalHeight += child.offsetHeight;
    }
  });

  if(totalHeight < 500) {
    wrapper.style.display = 'none';
    el.style.height = 'auto';
    el.classList.add('not-expandable');
  } else {

  toggle.addEventListener('click', () => {
      toggle.classList.add('product-description__toggle--hidden');
      close.classList.remove('product-description__toggle--hidden');
      el.classList.toggle('active');    
  });

  close.addEventListener('click', () => {
      toggle.classList.remove('product-description__toggle--hidden');
      close.classList.add('product-description__toggle--hidden');
      el.classList.toggle('active');
  });

}
};

export default init;
